import { styles } from './template.scss';
import { styles as commonStyles } from '../../assets/common.scss';

export const templateRawEventsConfigurationGrid = document.createElement('template');

templateRawEventsConfigurationGrid.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <gz-grid-view hideFooter showGlobalActions hasSelectableRows>
      <div class="controls-header" slot="grid-header-actions-slot">
        <!-- button text is added in view, because it needs to be translated -->
        <gz-select id="changeStatusSelector" disabled  class="primary">
          <gz-button id="changeStatusButton" type="full" color="primary" buttonheight="medium">
          </gz-button>
        </gz-select>
        </div>
      </div>
    </gz-grid-view>
  </div>
`;
